<template>
  <dv-capsule-chart :config="config" style="width:300px;height:200px" />
</template>

<script>
export default {
  name: "ZGRanking2",
  data() {
    return {
      config: {},
    }
  },
  methods:{
  },
  mounted() {
  },
  created() {
    let user_id = window.localStorage.getItem('user_id');

    const data = {
      'user_id': user_id
    };
    this.$api.zgu_area_count(data).then(res=> {
      this.config = {
        data: res,
        colors: ['#e062ae', '#fb7293', '#e690d1', '#32c5e9', '#96bfff'],
        unit: '个',
        showValue: true
      }
    })
  },
  watch: {
    message(value) {
      this.init();
    },
  }
}
</script>

<style scoped>

</style>